import {selection} from "d3-selection";
import selection_interrupt from "./interrupt";
import selection_transition from "./transition";

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-transition/src/selection/index.js
// module id = ../../../../d3-transition/src/selection/index.js
// module chunks = 4